/* eslint-disable */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';

import { translate } from 'react-i18next';

import { Row, Col } from 'react-flexbox-grid';

import { withStyles } from 'material-ui/styles';
import Button from 'material-ui/Button';
import { CircularProgress } from 'material-ui/Progress';

import * as moment from 'moment';

import teoLogo from '../../assets/images/teoLogoBleu.png';

import { default as HeaderImage } from '../../assets/images/svg/TEOMainHeader.svg';

import Typography from 'material-ui/Typography';
import CookieConsent from 'react-cookie-consent';

import {
  auth0Login,
  handleAuthenticationAuth0,
  checkCookieConsent,
  acceptCookies,
  declineCookies,
} from '../../actions';

import { styles } from './style';

const cookiePolicyUrl = 'https://attributes-preprod.netlify.app/cookies-policy';
const privacyPolicyUrl =
  'https://attributes-preprod.netlify.app/privacy-policy';

class Landing extends Component {
  static contextTypes = {
    router: PropTypes.func.isRequired,
  };

  static defaultProps = {
    zoom: 16,
  };

  componentDidMount = () => {
    this.props.handleAuthenticationAuth0(this.props.history);
    this.props.checkCookieConsent();
  };

  state = {
    headerContentTextColor: '#ffffff',
  };

  render() {
    const { classes, t, loadingCheck, cookiesAccepted } = this.props;

    if (loadingCheck) {
      return (
        <div style={{ position: 'absolute', top: '50%', left: '50%' }}>
          <CircularProgress size={32} />
        </div>
      );
    }

    return (
      <div>
        <div
          style={{
            backgroundColor: '#ffffff',
            padding: 20,
            minHeight: '100vh',
            flexDirection: 'column',
            display: 'flex',
          }}
        >
          <Row xs={2} style={{ paddingTop: 0 }}>
            <img src={teoLogo} style={{ height: 140, marginLeft: 24 }} />
          </Row>
          <Row xs={8} style={{ flex: 1 }} middle="xs" center="xs">
            <Col xs={10}>
              <Row xs={12} center="xs">
                <Col xs={12}>
                  <img src={HeaderImage} />
                </Col>
              </Row>
              <Row xs={12} style={{ marginBottom: 30 }} center="xs">
                <Col xs={12}>
                  <span className={classes.myHeroTitle}>
                    Getting green, for real
                  </span>
                </Col>
              </Row>
              <Row xs={12} style={{ marginBottom: 30 }} center="xs">
                <Col xs={12} center="xs">
                  <span className={classes.myBaseline}>
                    With Attributes, you can prove your green energy origin in
                    real time.
                  </span>
                </Col>
              </Row>
              <Row xs={12} style={{ marginBottom: 30 }} center="xs">
                <Col xs={12}>
                  <Button
                    variant="flat"
                    aria-label={t('Log in')}
                    className={[classes.myHomeButtonText, classes.buttonHome]}
                    onClick={() => {
                      if (
                        cookiesAccepted === null ||
                        cookiesAccepted === false
                      ) {
                        alert('Cookies must be accepted to use Attributes');
                      } else {
                        this.props.auth0Login();
                      }
                    }}
                  >
                    {t('Log in')}
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row xs={2}>
            <Col xs={12}>
              <span className={classes.myFooterTextNew}>
                &copy; {moment().format('YYYY')} Attributes SAS | 
              </span>
              <a
                href="mailto:contact@attrtibutes.digital"
                className={classes.myFooterTextNew}
              >
                contact@attrtibutes.digital
              </a>
              <span className={classes.myFooterTextNew}>
                {' '}
                | 1 Place Samuel-Champlain 92400 Courbevoie France |{' '}
              </span>
              <a
                href={privacyPolicyUrl}
                className={classes.myFooterTextNew}
                target="_blank"
              >
                {t('Privacy policy')}
              </a>
            </Col>
          </Row>

          <CookieConsent
            location="bottom"
            buttonText="I accept"
            enableDeclineButton
            onDecline={() => {
              this.props.declineCookies();
            }}
            onAccept={() => {
              this.props.acceptCookies();
            }}
            style={{
              background: '#ffffff',
              color: '#F87733',
              borderTop: '1px solid #F87733',
            }}
            buttonStyle={{
              margin: 0,
              marginRight: 20,
              padding: '0 16px',
              opacity: 1,
              fontSize: '0.5rem',
              letterSpacing: '1.3px',
              fontFamily:
                '"Inter-Regular", "Avenir", "Roboto", "Helvetica", "Arial", sans-serif',
              fontWeight: 'bold',
              lineHeight: '1.55rem',
              color: '#ffffff',
              border: 'none',
              borderRadius: 4,
              textTransform: 'uppercase',
              backgroundColor: '#F87733',
              backgroundImage: 'linear-gradient(#F59B6B,#F87733)',
              backgroundSize: '100%',
              backgroundRepeat: 'no-repeat',
              boxShadow: '0px 8px 24px 0px rgb(248 119 51 / 40%)',
              transition: 'all .5s ease',
              textDecoration: 'none',
            }}
            declineButtonStyle={{
              margin: 0,
              marginRight: 20,
              padding: '0 16px',
              opacity: 1,
              fontSize: '0.5rem',
              letterSpacing: '1.3px',
              fontFamily:
                '"Inter-Regular", "Avenir", "Roboto", "Helvetica", "Arial", sans-serif',
              fontWeight: 'bold',
              lineHeight: '1.55rem',
              color: '#F87733',
              borderRadius: 4,
              textTransform: 'uppercase',
              backgroundColor: '#ffffff',
              backgroundSize: '100%',
              backgroundRepeat: 'no-repeat',
              boxShadow: '0px 8px 24px 0px rgb(248 119 51 / 40%)',
              transition: 'all .5s ease',
              textDecoration: 'none',
              border: '1px solid #F87733',
            }}
            expires={150}
          >
            <Typography className={classes.cookieConsentTitle} gutterBottom>
              What do we use cookies for ?
            </Typography>
            <Typography className={classes.cookieConsentText} gutterBottom>
              We use cookies and similar technologies to recognize you when you
              are logged in. To learn more about cookies, including how to
              disable them, view our{' '}
              <a
                href={cookiePolicyUrl}
                style={{ color: '#F87733' }}
                target="_blank"
              >
                cookie policy
              </a>
              . By clicking "I accept" on this banner, you consent to the use of
              cookies unless you have disabled them.
            </Typography>
          </CookieConsent>
        </div>
      </div>
    );
  }
}

Landing.contextTypes = {
  router: PropTypes.object,
};
Landing.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = ({ loginReducer, utilsReducer }) => {
  const { loading, loadingCheck } = loginReducer;
  const { cookiesAccepted } = utilsReducer;
  return { loading, loadingCheck, cookiesAccepted };
};

const mapDispatchToProps = {
  auth0Login,
  handleAuthenticationAuth0,
  checkCookieConsent,
  acceptCookies,
  declineCookies,
};

Landing = withStyles(styles, { name: 'Landing' })(Landing);
Landing = translate('translations')(Landing);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Landing)
);



// WEBPACK FOOTER //
// ./src/components/Landing/Landing.js